import Vue from 'vue'
import VueRouter from 'vue-router'

import navigationRoutes from './routes/navigation'
import authRoutes from './routes/auth'
import serviceRoutes from './routes/service'
import profileRoutes from './routes/profile'
import walletRoutes from './routes/wallet'
import contentRoutes from './routes/content'
import legacyRoutes from './routes/legacy'
import { hasAuthToken } from './auth-access'

Vue.use(VueRouter)

// 统一维护页面路由；统一公开路径和路由名称，旧路径通过 legacyRoutes 透明跳转。
const routes = [
  ...navigationRoutes,
  ...authRoutes,
  ...serviceRoutes,
  ...profileRoutes,
  ...walletRoutes,
  ...contentRoutes,
  ...legacyRoutes,
]

const router = new VueRouter({ routes })

// 登录与注册是仅有的公开页面；其余页面（含根路径和历史重定向）均需登录。
router.beforeEach((to, from, next) => {
  const isPublic = to.matched.some(record => record.meta && record.meta.public === true)

  if (isPublic || hasAuthToken()) {
    next()
    return
  }

  // 记录原页面，成功登录后恢复；不允许游客先进入受保护组件。
  next({
    name: 'auth-login',
    query: { redirect: to.fullPath },
    replace: true,
  })
})

// 保留旧版 push 包装行为。
const originPush = VueRouter.prototype.push
VueRouter.prototype.push = function (location, resolve, reject) {
  if (resolve && reject) {
    originPush.call(this, location, resolve, reject)
  } else {
    originPush.call(this, location, () => {}, () => {})
  }
}

export default router
